import axios from '@/libs/axios'

const API_BASE_URL = '/catedraticos'

export default {
  // Obtener todos los catedráticos
  async getAll() {
    try {
      const response = await axios.get(API_BASE_URL)
      return response.data
    } catch (error) {
      console.error('Error fetching teachers:', error)
      throw error
    }
  },

  // Obtener catedráticos activos (el endpoint principal ya filtra por estado activo)
  async getActive() {
    try {
      const response = await axios.get(API_BASE_URL)
      return response.data
    } catch (error) {
      console.error('Error fetching active teachers:', error)
      throw error
    }
  },

  // Obtener un catedrático por ID
  async getById(id) {
    try {
      const response = await axios.get(`${API_BASE_URL}/${id}`)
      return response.data
    } catch (error) {
      console.error('Error fetching teacher:', error)
      throw error
    }
  },

  // Obtener catedráticos competentes para un curso (temporal - usar endpoint principal)
  async getCompetentForCourse(cursoId) {
    try {
      const response = await axios.get(API_BASE_URL)
      // TODO: Implementar filtrado por competencias cuando esté disponible en el backend
      return response.data
    } catch (error) {
      console.error('Error fetching competent teachers:', error)
      throw error
    }
  },

  // Obtener cursos que puede impartir un catedrático (temporal - usar endpoint principal)
  async getCoursesForTeacher(catedraticoId) {
    try {
      const response = await axios.get(API_BASE_URL)
      // TODO: Implementar filtrado por catedrático cuando esté disponible en el backend
      return response.data
    } catch (error) {
      console.error('Error fetching teacher courses:', error)
      throw error
    }
  },

  // Crear un nuevo catedrático
  async create(teacherData) {
    try {
      const response = await axios.post(API_BASE_URL, teacherData)
      return response.data
    } catch (error) {
      console.error('Error creating teacher:', error)
      throw error
    }
  },

  // Actualizar un catedrático
  async update(id, teacherData) {
    try {
      const response = await axios.put(`${API_BASE_URL}/${id}`, teacherData)
      return response.data
    } catch (error) {
      console.error('Error updating teacher:', error)
      throw error
    }
  },

  // Eliminar un catedrático
  async delete(id) {
    try {
      const response = await axios.delete(`${API_BASE_URL}/${id}`)
      return response.data
    } catch (error) {
      console.error('Error deleting teacher:', error)
      throw error
    }
  },

  // Asignar competencia a un catedrático (temporal - no implementado)
  async assignCompetence(catedraticoId, cursoId) {
    try {
      // TODO: Implementar cuando esté disponible en el backend
      console.warn('assignCompetence no implementado en el backend')
      return { success: true, message: 'Funcionalidad no implementada' }
    } catch (error) {
      console.error('Error assigning competence:', error)
      throw error
    }
  },

  // Remover competencia de un catedrático (temporal - no implementado)
  async removeCompetence(catedraticoId, cursoId) {
    try {
      // TODO: Implementar cuando esté disponible en el backend
      console.warn('removeCompetence no implementado en el backend')
      return { success: true, message: 'Funcionalidad no implementada' }
    } catch (error) {
      console.error('Error removing competence:', error)
      throw error
    }
  }
}